import React from "react";

export const navigationRef: any = React.createRef();

export function nextStep() {
  navigationRef.current?.nextStep();
}
export function nextStepB() {
  navigationRef.current?.nextStep();
}

export function previousStep() {
  navigationRef.current?.previousStep();
}

export function goToStep(step: string | number) {
  navigationRef.current?.goToStep(step);
}

export function isActive() {
  /* eslint-disable */
  // prettier-ignore
  navigationRef.current?.isActive;
}

export function currentStep() {
  /* eslint-disable */
  // prettier-ignore
  navigationRef.current?.currentStep;
}
